import * as React from "react";
import { _, Model } from "@flowable/forms";
import moment from "moment";
import styles from "./ResearchTeamBudget.css";
import ResearchTeamBudgetPeriod from "./ResearchTeamBudgetPeriod";
import ResearchTeamBudgetPeriodSelection from "./ResearchTeamBudgetPeriodSelection";
import BudgetPeriodDetail from "./BudgetPeriodDetail";
import { request } from "utils/proxy";
import { v4 as uuidv4 } from "uuid";

class ResearchTeamBudget extends Model.StatefulFormComponent {
	constructor (props) {
		super(props);
		this.state = {
			researchTeam: [],
			selectedBudgetPeriodIndex: null,
			startDate: "",
			endDate: "",
			loading: true,
			researchTeamBudget: [],
			sortedTeam: []
		};
	}

	componentDidMount () {
		const { config } = this.props;
		const initialValue = this.props.config.value || [];
		const researchTeam = _.get(config, "extraSettings.cayuseResearchTeam");
		this.setState({ researchTeamBudget: initialValue });

		const teamMemberPromises = [];
		const memberById = {};

		if (researchTeam !== null) {
			for (let i = 0; i < researchTeam.length; i++) {
				const memberId = researchTeam[i].member;
				memberById[memberId] = researchTeam[i];
				teamMemberPromises.push(request("/sp/api/person/" + memberId));
			}
		}

		Promise.all(teamMemberPromises)
			.then(promiseResults => {
				const sortedTeam = [];
				for (const person of promiseResults) {
					const member = memberById[person.id];

					const associationsById = {};
					for (const association of person.associations) {
						associationsById[association.id] = association;
					}

					for (const association of member.associations) {
						const completeAssociation = associationsById[association.association];
						sortedTeam.push({
							id: uuidv4(), // we can't use existing id's, since it's not enforced that a research team assignment exists exactly once
							name: person.name,
							association: completeAssociation.name,
							isCalendarAppointment: completeAssociation.isCalendarAppointment,
							isAcademicAppointment: completeAssociation.isAcademicAppointment,
							isSummerAppointment: completeAssociation.isSummerAppointment,
							totalEffort: 0
						});
					}
				}

				this.setState({
					researchTeam: researchTeam,
					sortedTeam: sortedTeam,
					startDate: _.get(config, "extraSettings.cayuseStartDate"),
					endDate: _.get(config, "extraSettings.cayuseEndDate"),
					loading: false,
				});
			});
	}


	render () {
		const {
			selectedBudgetPeriodIndex,
			startDate,
			endDate,
			loading,
			sortedTeam,
			researchTeamBudget
		} = this.state;

		const { Components, onChange } = this.props;


		const createResearchTeam = () => {
			let teamMap = {};
			for (const teamMember of sortedTeam) {
				teamMap[teamMember.id] = {
					costShareEffortC: 0,
					sponsoredEffortC: 0,
					costShareEffortA: 0,
					costShareEffortS: 0,
					sponsoredEffortA: 0,
					sponsoredEffortS: 0,
					totalEffort: 0,
					isCalendarAppointment: teamMember.isCalendarAppointment,
					isAcademicAppointment: teamMember.isAcademicAppointment,
					isSummerAppointment: teamMember.isSummerAppointment
				};
			}

			return teamMap;
		};
		const setBudgetPeriodAmount = budgetPeriodAmount => {
			let budgetPeriodChangeAmount = budgetPeriodAmount - researchTeamBudget.length;

			if (budgetPeriodChangeAmount < 0) {
				budgetPeriodChangeAmount = 0;
			}

			const newResearchTeamBudget = [
				...researchTeamBudget,
				...Array(budgetPeriodChangeAmount).fill().map(() => ({
					budgetPeriod: { startDate: null, endDate: null },
					researchTeam: createResearchTeam()
				}
				)) ].slice(0, budgetPeriodAmount);
			if (newResearchTeamBudget.length > 0) {
				newResearchTeamBudget.length = budgetPeriodAmount;
				newResearchTeamBudget[0].budgetPeriod.startDate = startDate;
				newResearchTeamBudget[budgetPeriodAmount - 1].budgetPeriod.endDate = endDate;
				setBudgetPeriodList(newResearchTeamBudget);
			}
		};
		const setBudgetPeriodList = researchTeamBudget => {
			const newValue = JSON.parse(JSON.stringify(researchTeamBudget));
			this.setState({ researchTeamBudget: newValue });
			onChange(newValue);
		};
		const setBudgetPeriod = budgetPeriod => {
			researchTeamBudget[selectedBudgetPeriodIndex] = budgetPeriod;
			setBudgetPeriodList(researchTeamBudget);
		};
		const setSelectedBudgetPeriod = index => {
			this.setState({ selectedBudgetPeriodIndex: index });
		};

		const formatDate = period => {
			let endDate = period.endDate === null ? "end date" : moment(period.endDate).utc().format("MM/DD/YYYY");
			let startDate = period.startDate === null ? "start date" : moment(period.startDate).utc().format("MM/DD/YYYY");

			return startDate + " - " + endDate;
		};

		const selectConfigDropDown = {
			label: "Budget Period",
			$path: "budgetPeriod",
			type: "select",
			$errors: [],
			value: selectedBudgetPeriodIndex,
			extraSettings: {
				dataSource: "Static",
				identity: "value",
				enableAutocomplete: false,
				items: researchTeamBudget.map((entry, index) => {
					return {
						text: formatDate(entry.budgetPeriod),
						value: index
					};
				})
			}
		};
		//TODO: add dictionary

		return loading ? (<div>Loading ...</div>) :
			sortedTeam.length === 0 ?
				<h2 className={styles.noTeam}>No Research Team Found</h2> : (
					<div>
						<p className={styles.title}>Budget Periods</p>
						<div className={styles.topText}>
							<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                  labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
                  voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
						</div>
						<ResearchTeamBudgetPeriod startDate={startDate} endDate={endDate}
							initialBudgetPeriod={researchTeamBudget.length}
							{...this.props} onChange={setBudgetPeriodAmount}
						/>

						<ResearchTeamBudgetPeriodSelection {...this.props}
							onChange={setBudgetPeriodList}
							researchTeamBudget={researchTeamBudget}
						/>
						<p className={styles.title}>Effort</p>
						<div className={styles.bottomText}>
							<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                    labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                    laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
                    voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                    cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
						</div>
						<Components.select {...this.props} config={selectConfigDropDown}
							onChange={index => setSelectedBudgetPeriod(index)}
						/>
						{researchTeamBudget.map((researchTeamBudgetItem, index) => {
							// this needs to be a loop, otherwise the context is going to be re-used for the <BudgetPeriodDetail>
							if (index === selectedBudgetPeriodIndex) {
								return (
									<BudgetPeriodDetail {...this.props}
										key={`budget-period-detail-${index}`}
										researchTeamBudgetPeriod={researchTeamBudget[index]}
										sortedTeam={sortedTeam}
										onChange={setBudgetPeriod}
									/>
								);
							} else {
								return "";
							}
						})}
					</div>
				);
	}
}

export default ResearchTeamBudget;


